import React from 'react';
import TagsInput from 'react-tagsinput'

import PropTypes from 'prop-types';
import Notifications from '../../../../hof/notifications';
import {withTranslation} from "react-i18next";

const isTagLocked = (tag, lockedTags) => !!lockedTags.find(locked => locked === tag);

class HiddenCommentersInput extends React.Component {

    static propTypes = {
        onChange: PropTypes.func.isRequired,
        value: PropTypes.arrayOf(PropTypes.string).isRequired
    };

    static defaultProps = {
        value: [],
        lockedTags: []
    };

    componentDidMount() {
        const {lockedTags} = this.props;
        this.setState({lockedTags: [...lockedTags]});
    }

    handleChange(tags) {
        this.setState({tags})
        const {onChange} = this.props;
        onChange(tags);
    }

    defaultRenderTag(props, lockedTags) {
        let {tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other} = props
        return (
            <span key={key} {...other}>
                {getTagDisplayValue(tag)}
                {!disabled && !isTagLocked(tag, lockedTags) &&
                <a className={classNameRemove} onClick={(e) => {
                    if (!isTagLocked(key, lockedTags)) {
                        onRemove(key);
                    }
                }}/>
                }
            </span>
        )
    }

    render() {
        const {value, lockedTags, t} = this.props;
        const USERNAME_REGEX = /^(?=.{3,16}$)[a-z](-[a-z0-9](-[a-z0-9])*)?(-[a-z0-9]|[a-z0-9])*(?:\.[a-z](-[a-z0-9](-[a-z0-9])*)?(-[a-z0-9]|[a-z0-9])*)*$/;
        return (
            <TagsInput
                value={value}
                onChange={this.handleChange.bind(this)}
                validationRegex={USERNAME_REGEX}
                addOnBlur={true}
                onlyUnique={true}
                removeKeys={[]}
                inputProps={{placeholder: t('settings.hidden_commenters.add_username')}}
                onValidationReject={(tags)=>{
                    const [tag] = tags;
                    if(tag !== '') {
                        Notifications.showNotification(
                            t('settings.hidden_commenters.notifications.invalid_username.title'),
                            `${tags[0]} ${t('settings.hidden_commenters.notifications.invalid_username.body')}`,
                            Notifications.Colors.ERROR)
                    }
                }}
                renderTag={(props) => this.defaultRenderTag(props, lockedTags)}
                addKeys={[9, 13, 32]} // tab, enter, space
            />
        )
    }
}

const renderHiddenCommentersInput = (props) => {
    const {input, meta: {touched, error}, lockedTags, t} = props;
    console.log(props);
    return (
        <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
            <HiddenCommentersInput {...input} lockedTags={lockedTags} t={t}/>
            {touched && error && <span className="form__form-group-error">{error}</span>}
        </div>
    );
};

renderHiddenCommentersInput.propTypes = {
    input: PropTypes.shape({
        onChange: PropTypes.func,
        name: PropTypes.string,
        value: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
    lockedTags: PropTypes.arrayOf(PropTypes.string),
};

renderHiddenCommentersInput.defaultProps = {
    meta: null
};

export default  withTranslation('dashboard')(renderHiddenCommentersInput);
